"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messagingFormDefaultValues = exports.messagingFormResolver = exports.messagingFormSchema = exports.videoDataSchema = exports.videoVidyardSchema = exports.videoVidyardVideoUrlSchema = exports.videoVidyardImageUrlSchema = exports.videoEmbedSchema = exports.videoUrlSchema = exports.videoTypeSchema = exports.messageTemplateIdSchema = exports.messageBodySchema = exports.messageSubjectSchema = exports.MESSAGING_SUBJECT_LIMIT = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _yup = require("yup");

var _yup2 = require("@hookform/resolvers/yup");

var _messaging = require("./messaging.types");

var rUrlProtocol = /^((https?|ftp):)?\/\//i;
var MESSAGING_SUBJECT_LIMIT = 255;
exports.MESSAGING_SUBJECT_LIMIT = MESSAGING_SUBJECT_LIMIT;
var messageSubjectSchema = (0, _yup.string)().label('Message Subject').min(3).max(MESSAGING_SUBJECT_LIMIT).trim().nullable().default(null).required();
exports.messageSubjectSchema = messageSubjectSchema;
var messageBodySchema = (0, _yup.string)().label('Message Body').min(10).trim().nullable().default(null).when(['$bodyCharsLimit'], function (bodyCharsLimit, schema) {
  return bodyCharsLimit ? schema.max(bodyCharsLimit).required() : schema;
}).required();
exports.messageBodySchema = messageBodySchema;
var messageTemplateIdSchema = (0, _yup.number)().label('Template Id').integer().default(null).nullable();
exports.messageTemplateIdSchema = messageTemplateIdSchema;
var capturePhoneSchema = (0, _yup.boolean)().default(false);
var captureEmailSchema = (0, _yup.boolean)().default(false);
var captureDateSchema = (0, _yup.boolean)().default(true);
var captureAffidavitSchema = (0, _yup.boolean)().default(false);
var gifterAffidavitSchema = (0, _yup.string)().label('Custom terms & conditions').nullable().default(null).trim().max(255).when(_messaging.RecipientActionsFields.CaptureAffidavit, function (isEnabled, schema) {
  return isEnabled ? schema.required() : schema;
});
var captureQuestionSchema = (0, _yup.boolean)().default(false);
var gifterQuestionSchema = (0, _yup.string)().label('Custom questions').nullable().default(null).trim().max(255).when(_messaging.RecipientActionsFields.CaptureQuestion, function (isEnabled, schema) {
  return isEnabled ? schema.required() : schema;
});
var messageSchema = (0, _yup.object)().shape({
  [_messaging.MessageFields.MessageSubject]: messageSubjectSchema,
  [_messaging.MessageFields.MessageBody]: messageBodySchema,
  [_messaging.MessageFields.TemplateId]: messageTemplateIdSchema,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  sendAsPersons: (0, _yup.array)().default([]).nullable()
});
var recipientActionsSchema = (0, _yup.object)().shape({
  [_messaging.RecipientActionsFields.CapturePhone]: capturePhoneSchema,
  [_messaging.RecipientActionsFields.CaptureEmail]: captureEmailSchema,
  [_messaging.RecipientActionsFields.CaptureDate]: captureDateSchema,
  [_messaging.RecipientActionsFields.CaptureAffidavit]: captureAffidavitSchema,
  [_messaging.RecipientActionsFields.GifterAffidavit]: gifterAffidavitSchema,
  [_messaging.RecipientActionsFields.CaptureQuestion]: captureQuestionSchema,
  [_messaging.RecipientActionsFields.GifterQuestion]: gifterQuestionSchema
});
var meetingOwnerIdSchema = (0, _yup.number)().nullable().default(0);
var meetingIsAttendeeEnabledSchema = (0, _yup.boolean)().default(false);
var meetingAttendeeSchema = (0, _yup.array)().label('Meeting attendee').default([]).when(_messaging.MeetingHostsFields.IsAttendeeEnabled, {
  is: function is(isAttendeeEnabled) {
    return isAttendeeEnabled;
  },
  then: (0, _yup.array)().min(1, 'Meeting attendee is required').required()
});
var meetingHostsSchema = (0, _yup.object)().shape({
  [_messaging.MeetingHostsFields.OwnerId]: meetingOwnerIdSchema,
  [_messaging.MeetingHostsFields.IsAttendeeEnabled]: meetingIsAttendeeEnabledSchema,
  [_messaging.MeetingHostsFields.AttendeeIds]: meetingAttendeeSchema
}).default({
  [_messaging.MeetingHostsFields.OwnerId]: 0,
  [_messaging.MeetingHostsFields.IsAttendeeEnabled]: false,
  [_messaging.MeetingHostsFields.AttendeeIds]: []
});
var videoTypeSchema = (0, _yup.string)().nullable().default(null).oneOf([].concat((0, _toConsumableArray2.default)(Object.values(_messaging.MessageVideoType)), [null]));
exports.videoTypeSchema = videoTypeSchema;
var videoUrlSchema = (0, _yup.string)().label('Video Url').nullable().default(null).trim().max(255, 'Link must not exceed 255 characters').url('Link should contain a valid url').when(_messaging.VideoDataFields.Type, function (type, schema) {
  return type === _messaging.MessageVideoType.Embed ? schema.required() : schema;
});
exports.videoUrlSchema = videoUrlSchema;
var videoEmbedSchema = (0, _yup.object)().shape({
  [_messaging.VideoDataEmbedFields.VideoUrl]: videoUrlSchema
}).nullable().default(null);
exports.videoEmbedSchema = videoEmbedSchema;
var videoVidyardImageUrlSchema = (0, _yup.string)().nullable().default(null).trim().max(255, 'Link must not exceed 255 characters').matches(rUrlProtocol, {
  message: 'Protocol http:// or https:// is missing in the link',
  excludeEmptyString: true
}).url('Link should contain a valid url');
exports.videoVidyardImageUrlSchema = videoVidyardImageUrlSchema;
var videoVidyardVideoUrlSchema = (0, _yup.string)().nullable().default(null).trim().max(255, 'Link must not exceed 255 characters').matches(rUrlProtocol, {
  message: 'Protocol http:// or https:// is missing in the link',
  excludeEmptyString: true
}).url('Link should contain a valid url');
exports.videoVidyardVideoUrlSchema = videoVidyardVideoUrlSchema;
var videoVidyardSchema = (0, _yup.object)().shape({
  [_messaging.VideoDataVidyardFields.ImageUrl]: videoVidyardImageUrlSchema,
  [_messaging.VideoDataVidyardFields.VideoUrl]: videoVidyardVideoUrlSchema
}).nullable().default(null).when(_messaging.VideoDataFields.Type, function (type, schema) {
  return type === _messaging.MessageVideoType.Vidyard ? schema.required('Vidyard is required') : schema;
});
exports.videoVidyardSchema = videoVidyardSchema;
var videoDataSchema = (0, _yup.object)().shape({
  [_messaging.VideoDataFields.Type]: videoTypeSchema,
  [_messaging.VideoDataFields.Embed]: videoEmbedSchema,
  [_messaging.VideoDataFields.Vidyard]: videoVidyardSchema
});
exports.videoDataSchema = videoDataSchema;
var messagingFormSchema = (0, _yup.object)().shape({
  [_messaging.MessagingDataFields.Message]: messageSchema,
  [_messaging.MessagingDataFields.RecipientActions]: recipientActionsSchema,
  [_messaging.MessagingDataFields.MeetingHosts]: meetingHostsSchema,
  [_messaging.MessagingDataFields.VideoData]: videoDataSchema
});
exports.messagingFormSchema = messagingFormSchema;
var messagingFormResolver = (0, _yup2.yupResolver)(messagingFormSchema);
exports.messagingFormResolver = messagingFormResolver;
var messagingFormDefaultValues = messagingFormSchema.getDefault();
exports.messagingFormDefaultValues = messagingFormDefaultValues;